import { PieChartOutlined, TableOutlined } from "@ant-design/icons";
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Chip,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from "@mui/material";
import { useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import SimpleBar from "components/third-party/SimpleBar";
import { ICirculationIssueOverdueResult } from "features/libraryDashboard/api/types";

type Props = {
  data: ICirculationIssueOverdueResult[];
};

const MemberTypeWiseCirculation = ({ data }: Props) => {
  const [view, setView] = useState("Visual");
  const hasData = data && data.length > 0;

  const barData = data?.map((d) => ({
    name: d.name,
    issued: d.issued,
    overDue: d.overdue,
  }));
  return (
    <>
      <Card sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <CardHeader
          sx={{ p: 2 }}
          title="Member Type wise circulation"
          action={
            <Grid container spacing={1}>
              <Grid item>
                <Chip
                  icon={<PieChartOutlined />}
                  label="Visual"
                  color={view === "Visual" ? "primary" : "default"}
                  onClick={() => setView("Visual")}
                />
              </Grid>
              <Grid item>
                <Chip
                  label="Tabular"
                  icon={<TableOutlined />}
                  color={view === "Tabular" ? "primary" : "default"}
                  onClick={() => setView("Tabular")}
                />
              </Grid>
            </Grid>
          }
        />
        <Divider />
        <CardContent
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {!hasData ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: 250,
                width: "100%",
              }}
            >
              <Typography variant="h5" color="text.secondary">
                No data available
              </Typography>
            </Box>
          ) : (
            <>
              {view === "Visual" && (
                <ResponsiveContainer width="100%" height={450}>
                  <BarChart
                    width={500}
                    height={300}
                    data={barData}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 20,
                      bottom: 5,
                    }}
                  >
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar barSize={50} dataKey="issued" fill="#73bf7d" />
                    <Bar barSize={50} dataKey="overDue" fill="#eb4b5e" />
                  </BarChart>
                </ResponsiveContainer>
              )}

              {view === "Tabular" && (
                <TableContainer sx={{ mt: 0, maxHeight: 340 }}>
                  <SimpleBar sx={{ height: 290 }}>
                    <Table size="small">
                      <TableHead
                        sx={{
                          position: "sticky",
                          top: -1,
                          zIndex: 2,
                        }}
                      >
                        <TableRow>
                          <TableCell>Member Type</TableCell>
                          <TableCell align="center">Issued</TableCell>
                          <TableCell align="center">Over Due</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data?.map((row) => (
                          <TableRow hover key={row.id}>
                            <TableCell>{row.name}</TableCell>
                            <TableCell align="center">{row.issued}</TableCell>
                            <TableCell align="center">{row.overdue}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </SimpleBar>
                </TableContainer>
              )}
            </>
          )}
        </CardContent>
      </Card>
    </>
  );
};
export default MemberTypeWiseCirculation;
